import {
    COLOR_SWATCHES_ONHOVER,
    BUNDLE_COLOR_SWATCHES_ON_HOVER,
} from '../actionTypes/ColorSwatchesActionTypes';

export const colorSwatchesHoverAction = (
    option,
    isSwatchesOnHover,
    updateProductImage,
    sourceMiniPDP
) => ({
    type: COLOR_SWATCHES_ONHOVER,
    payload: { option, isSwatchesOnHover, updateProductImage, sourceMiniPDP },
});

export const bundleColorSwatchHover = (payload) => ({
    type: BUNDLE_COLOR_SWATCHES_ON_HOVER,
    payload,
});
